import React from 'react';
import SvgIcon from './SvgIcon';

const CalendarDate = props => (
    <SvgIcon viewBox="0 0 24 24" {...props}>
        <path
            d="M22.5 2.501h-21a1 1 0 00-1 1v19a1 1 0 001 1h21a1 1 0 001-1v-19a1 1 0 00-1-1zM5.5.501v5M18.5.501v5M.5 7.501h23M6.5 19.001h5"
            stroke="currentColor"
            strokeMiterlimit={10}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M9 19v-7.5a.5.5 0 00-.812-.391L6.5 12.46M15.5 19l2.931-7.255a.469.469 0 00-.005-.5.545.545 0 00-.464-.245H14a.5.5 0 00-.5.5v1"
            stroke="currentColor"
            strokeMiterlimit={10}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </SvgIcon>
);

CalendarDate.displayName = 'CalendarDateIcon';

export default CalendarDate;
